import { useState, useEffect } from "react";
import React from "react";
import ThemeMaker from "../../components/thememaker";
import { tokenDecode } from "../../utils/helper";
import { toast } from 'react-toastify';
import axios from "axios";
import { config } from "../../utils/config";
import "../../index.css";
import CircularProgress from '@mui/material/CircularProgress';

const { apiEndpoint } = config;

const MODULE_LIST = [
    { key: "seller", label: "Seller Management", icon: "fas fa-store", superOnly: true },
    // { key: "user", label: "User Management", icon: "fas fa-users" },
    { key: "product", label: "Product Management", icon: "fas fa-box-open", sellerOnly: true },
    { key: "order", label: "Order Management", icon: "fas fa-shopping-cart" },
    { key: "igm", label: "IGM / Support", icon: "fas fa-headset" },
    { key: "transaction", label: "Transaction Management", icon: "fas fa-file-invoice-dollar" },
    { key: "category", label: "Category Management", icon: "fas fa-th-large", superOnly: true },
    // { key: "tax", label: "Tax Management", icon: "fas fa-percent", superOnly: true },
    // { key: "role", label: "Role & Permissions", icon: "fas fa-user-shield" },
    // { key: "location", label: "Location Management", icon: "fas fa-map-marker-alt" },
];

const Roles = () => {
    const [isUpdate, setIsUpdate] = useState(false);
    const [isListig, setIsListing] = useState(false); // Default to listing view for better UX
    const [isLoading, setIsLoading] = useState(false);
    const [listingLoading, setListingLoading] = useState(false);
    const [listingData, setListingData] = useState<any[]>([]);
    const [searchTerm, setSearchTerm] = useState("");

    const decode = tokenDecode();
    const { data } = decode || {};
    const deleteable = data?.user[0]?.id;

    const permArray = Array.isArray(data?.permission)
        ? data.permission
        : Object.entries(data?.permission || {}).map(([tab_name, p]: any) => ({ tab_name, ...p }));

    const permission = permArray.reduce((acc: any, p: any) => {
        if (p && p.tab_name) {
            acc[p.tab_name] = {
                p_read: p.p_read ?? p.read ?? true,
                p_write: p.p_write ?? p.write ?? true,
                p_update: p.p_update ?? p.update ?? true,
                p_delete: p.p_delete ?? p.delete ?? true,
            };
        }
        return acc;
    }, {});

    const role = permission.role || {};
    const userObj = Array.isArray(data?.user) ? data?.user[0] : (data?.user || {});
    const { seller_id, parent_id, role_id } = userObj || {};

    const isSuperAdmin = Number(seller_id) === 1 || Number(userObj?.id) === 1 || Number(role_id) === 1 || (Number(seller_id) === 0 && Number(parent_id) === 1);
    const isProductAllowed = Number(parent_id) >= 1;

    const initialRoleData = {
        seller_id: decode?.data?.user?.seller_id,
        role_name: '',
        status: true,
        permission: {
            seller: { p_read: false, p_write: false, p_update: false, p_delete: false },
            user: { p_read: false, p_write: false, p_update: false, p_delete: false },
            product: { p_read: false, p_write: false, p_update: false, p_delete: false },
            order: { p_read: false, p_write: false, p_update: false, p_delete: false },
            category: { p_read: false, p_write: false, p_update: false, p_delete: false },
            tax: { p_read: false, p_write: false, p_update: false, p_delete: false },
            role: { p_read: false, p_write: false, p_update: false, p_delete: false },
            location: { p_read: false, p_write: false, p_update: false, p_delete: false },
            igm: { p_read: false, p_write: false, p_update: false, p_delete: false },
            transaction: { p_read: false, p_write: false, p_update: false, p_delete: false }
        }
    };

    const [roles, setRoles] = useState<any>(initialRoleData);
    const [rolesErrorData, setRolesErrorData] = useState<any>({ role_name: false });

    useEffect(() => {
        ListHanler();
    }, []);

    const errorHandler = (e: any) => {
        const { name, value } = e.target;
        if (name === "role_name") {
            if (!value || (typeof value === "string" && !value.trim())) {
                setRolesErrorData((prev: any) => ({ ...prev, role_name: true }));
            } else if (!/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(value.trim())) {
                setRolesErrorData((prev: any) => ({ ...prev, role_name: "invalid" }));
            } else {
                setRolesErrorData((prev: any) => ({ ...prev, role_name: false }));
            }
        }
    };

    const buildPayload = () => {
        const { permission, ...rest } = roles;
        const permissions = Object.entries(permission || {}).map(([tab_name, perms]: [string, any]) => ({
            tab_name,
            p_read: Boolean(perms.p_read),
            p_write: Boolean(perms.p_write),
            p_update: Boolean(perms.p_update),
            p_delete: Boolean(perms.p_delete),
        }));
        return { ...rest, permissions };
    };

    const creareRoleHandler = async () => {
        try {
            const roleNameRegex = /^[a-zA-Z][a-zA-Z0-9\s]*$/;
            const trimmedRoleName = (roles.role_name || "").trim();

            if (!trimmedRoleName) {
                setRolesErrorData({ ...rolesErrorData, role_name: true });
                toast.error("Please fill the required field!");
                return;
            }

            if (!roleNameRegex.test(trimmedRoleName)) {
                setRolesErrorData({ ...rolesErrorData, role_name: "invalid" });
                toast.error("Role name must start with a letter and cannot contain special characters!");
                return;
            }


            // Validate at least one permission is selected across any module
            const hasAtLeastOnePermission = Object.values(roles.permission || {}).some(
                (perms: any) => perms.p_read || perms.p_write || perms.p_update || perms.p_delete
            );
            if (!hasAtLeastOnePermission) {
                toast.error("Please select at least one permission (Read/Write/Update/Delete) for any module!");
                return;
            }

            setRolesErrorData({ ...rolesErrorData, role_name: false });
            setIsLoading(true);

            const { data } = await axios({
                url: `${apiEndpoint}/snp/roles/create`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: buildPayload()
            });
            setIsLoading(false);
            if (data.status === true) {
                toast.success("Role created successfully!");
                setRoles(initialRoleData);
                setIsListing(false);
                ListHanler();
            } else {
                toast.error(data.message || "Failed to create role!");
            }
        } catch (error: any) {
            setIsLoading(false);
            toast.error(error?.response?.data?.message || "Failed to create role!");
        }
    };

    const ListHanler = async () => {
        try {
            setListingLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/roles/getall`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    seller_id: decode?.data?.user?.seller_id,
                }
            });
            setListingLoading(false);
            if (data.status === true) {
                setListingData(data.roles || []);
            }
        } catch (error) {
            setListingLoading(false);
            console.log("Error loading roles:", error);
        }
    };

    const setCreate = () => {
        setIsListing(true);
        setIsUpdate(false);
        setRoles(initialRoleData);
        setRolesErrorData({ role_name: false });
    };

    const formatRoleFromApi = (fetchedRole: any) => {
        const defaultPermissions = JSON.parse(JSON.stringify(initialRoleData.permission));

        if (Array.isArray(fetchedRole?.permissions)) {
            fetchedRole.permissions.forEach((p: any) => {
                const tab = p.tab_name;
                if (tab && defaultPermissions[tab]) {
                    defaultPermissions[tab] = {
                        p_read: Boolean(p.p_read),
                        p_write: Boolean(p.p_write),
                        p_update: Boolean(p.p_update),
                        p_delete: Boolean(p.p_delete),
                    };
                }
            });
        }

        return {
            id: fetchedRole.id,
            role_name: fetchedRole.role_name || "",
            seller_id: fetchedRole.seller_id,
            status: Boolean(fetchedRole.status),
            permission: defaultPermissions
        };
    };

    const editRedirect = async (id: any) => {
        try {
            setIsListing(true);
            setIsUpdate(true);
            setIsLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/roles/get/${id}`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            setIsLoading(false);

            if (data && (data.status === true || data.status === 200)) {
                const targetRole = data.role || data.data;
                if (targetRole) {
                    setRoles(formatRoleFromApi(targetRole));
                }
            }
        } catch (error) {
            setIsLoading(false);
            console.log("Error fetching role details:", error);
        }
    };

    const updateRole = async () => {
        try {
            const roleNameRegex = /^[a-zA-Z][a-zA-Z0-9\s]*$/;
            const trimmedRoleName = (roles.role_name || "").trim();

            if (!trimmedRoleName) {
                setRolesErrorData({ ...rolesErrorData, role_name: true });
                toast.error("Please fill the required field!");
                return;
            }

            if (!roleNameRegex.test(trimmedRoleName)) {
                setRolesErrorData({ ...rolesErrorData, role_name: "invalid" });
                toast.error("Role name must start with a letter and cannot contain special characters!");
                return;
            }

            setRolesErrorData({ ...rolesErrorData, role_name: false });
            setIsLoading(true);
            const roleId = roles?.id;
            const fullPayload = buildPayload();
            const { id, ...payload } = fullPayload;
            const { data } = await axios({
                url: `${apiEndpoint}/snp/roles/update/${roleId}`,
                method: "PUT",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: payload
            });

            if (data && (data.status === true || data.status === 200)) {
                toast.success("Role updated successfully!");
                setIsListing(false);
                ListHanler();
            } else {
                toast.error(data.message || "Failed to update role!");
            }
            setIsLoading(false);
        } catch (error: any) {
            setIsLoading(false);
            toast.error(error?.response?.data?.message || "Failed to update role!");
        }
    };

    const deleteRole = async (id: any) => {
        if (!window.confirm("Are you sure you want to delete this role?")) return;
        try {
            setIsLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/roles/delete/${id}`,
                method: "DELETE",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            setIsLoading(false);
            if (data.status === true) {
                setListingData(listingData.filter((item: any) => item.id !== id));
                toast.success("Role deleted successfully!");
            } else {
                toast.error(data.message || "Failed to delete role!");
            }
        } catch (error: any) {
            setIsLoading(false);
            toast.error(error?.response?.data?.message || "Failed to delete role!");
        }
    };

    const handlePermissionToggle = (moduleKey: string, permKey: "p_read" | "p_write" | "p_update" | "p_delete") => {
        setRoles((prev: any) => ({
            ...prev,
            permission: {
                ...prev.permission,
                [moduleKey]: {
                    ...prev.permission[moduleKey],
                    [permKey]: !prev.permission[moduleKey]?.[permKey]
                }
            }
        }));
    };

    const toggleRowAll = (moduleKey: string) => {
        const currentPerms = roles?.permission?.[moduleKey] || {};
        const allChecked = currentPerms.p_read && currentPerms.p_write && currentPerms.p_update && currentPerms.p_delete;
        setRoles((prev: any) => ({
            ...prev,
            permission: {
                ...prev.permission,
                [moduleKey]: {
                    p_read: !allChecked,
                    p_write: !allChecked,
                    p_update: !allChecked,
                    p_delete: !allChecked
                }
            }
        }));
    };

    const visibleModules = MODULE_LIST.filter(m => {
        if (m.superOnly && !isSuperAdmin) return false;
        if ((m as any).sellerOnly && isSuperAdmin) return false;
        if (m.key === "product" && !isProductAllowed) return false;
        return true;
    });

    const toggleColumnAll = (permKey: "p_read" | "p_write" | "p_update" | "p_delete") => {
        const allChecked = visibleModules.every(m => roles?.permission?.[m.key]?.[permKey]);

        setRoles((prev: any) => {
            const updatedPerms = { ...prev.permission };
            visibleModules.forEach(m => {
                updatedPerms[m.key] = {
                    ...updatedPerms[m.key],
                    [permKey]: !allChecked
                };
            });
            return {
                ...prev,
                permission: updatedPerms
            };
        });
    };

    const filteredRoles = listingData.filter((item: any) =>
        (item?.role_name || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <ThemeMaker>
            <div className="row w-100 m-0 mt-2 px-2">
                <div className="col-12 p-0">
                    <div className="card shadow-sm border-0" style={{ borderRadius: "20px", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)" }}>

                        {/* ── Top Header & Tab Navigation ── */}
                        <div className="p-4 border-bottom d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "15px", borderColor: "#F1F5F9" }}>
                            <div>
                                <h4 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "24px" }}>
                                    Roles & Permissions
                                </h4>
                                <p className="text-muted m-0 mt-1" style={{ fontSize: "13px" }}>
                                    Manage administrative roles, module access, and user capabilities
                                </p>
                            </div>

                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                <button
                                    className="btn d-inline-flex align-items-center"
                                    style={{
                                        backgroundColor: isListig ? "#F97316" : "#F1F5F9",
                                        color: isListig ? "#FFFFFF" : "#475569",
                                        borderRadius: "12px",
                                        padding: "10px 20px",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        border: "none",
                                        transition: "all 0.2s ease"
                                    }}
                                    onClick={() => setCreate()}
                                >
                                    <i className="fas fa-plus-circle mr-2"></i>
                                    Create New Role
                                </button>

                                <button
                                    className="btn d-inline-flex align-items-center"
                                    style={{
                                        backgroundColor: !isListig ? "#F97316" : "#F1F5F9",
                                        color: !isListig ? "#FFFFFF" : "#475569",
                                        borderRadius: "12px",
                                        padding: "10px 20px",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        border: "none",
                                        transition: "all 0.2s ease"
                                    }}
                                    onClick={() => {
                                        setIsListing(false);
                                        ListHanler();
                                    }}
                                >
                                    <i className="fas fa-list mr-2"></i>
                                    Roles List ({listingData.length})
                                </button>
                            </div>
                        </div>

                        {/* ── Main Content Area ── */}
                        {isListig ? (
                            /* ── Form View (Create / Edit) ── */
                            <div className="p-4">
                                <div className="row">
                                    {/* Role Name */}
                                    <div className="col-md-6 mb-3">
                                        <label className="font-weight-bold mb-2" style={{ fontSize: "14px", color: "#334155" }}>
                                            Role Name <span className="text-danger">*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                className={`form-control ${rolesErrorData?.role_name ? 'is-invalid' : ''}`}
                                                name="role_name"
                                                placeholder="e.g. Store Manager, Catalog Executive"
                                                value={roles.role_name}
                                                maxLength={80}
                                                style={{
                                                    borderRadius: "10px",
                                                    borderColor: rolesErrorData?.role_name ? "#EF4444" : "#CBD5E1",
                                                    padding: "12px 16px",
                                                    fontSize: "14px",
                                                    height: "46px"
                                                }}
                                                onChange={(e) => {
                                                    setRoles({ ...roles, [e.target.name]: e.target.value });
                                                    if (rolesErrorData.role_name) errorHandler(e);
                                                }}
                                                onBlur={(e) => errorHandler(e)}
                                            />
                                        </div>
                                        {rolesErrorData?.role_name === true && (
                                            <span className="text-danger d-block mt-1" style={{ fontSize: "12px" }}>
                                                <i className="fas fa-exclamation-circle mr-1"></i> This field is required!
                                            </span>
                                        )}
                                        {rolesErrorData?.role_name === "invalid" && (
                                            <span className="text-danger d-block mt-1" style={{ fontSize: "12px" }}>
                                                <i className="fas fa-exclamation-circle mr-1"></i> Role name must start with a letter and special characters are not allowed!
                                            </span>
                                        )}
                                    </div>

                                    {/* Role Status Switch */}
                                    <div className="col-md-6 mb-3">
                                        <label className="font-weight-bold mb-2 d-block" style={{ fontSize: "14px", color: "#334155" }}>
                                            Status
                                        </label>
                                        <div className="d-flex align-items-center" style={{ height: "46px" }}>
                                            <div
                                                onClick={() => setRoles({ ...roles, status: !roles?.status })}
                                                style={{
                                                    width: "50px",
                                                    height: "26px",
                                                    backgroundColor: roles?.status ? "#10B981" : "#CBD5E1",
                                                    borderRadius: "20px",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    transition: "background-color 0.2s"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "20px",
                                                        height: "20px",
                                                        backgroundColor: "#FFFFFF",
                                                        borderRadius: "50%",
                                                        position: "absolute",
                                                        top: "3px",
                                                        left: roles?.status ? "27px" : "3px",
                                                        transition: "left 0.2s",
                                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                                    }}
                                                />
                                            </div>
                                            <span className="ml-3 font-weight-bold" style={{ fontSize: "14px", color: roles?.status ? "#10B981" : "#64748B" }}>
                                                {roles?.status ? "Active" : "Inactive"}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Permissions Matrix */}
                                    <div className="col-12 mt-2">
                                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap" style={{ gap: "10px" }}>
                                            <div>
                                                <h6 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "16px" }}>
                                                    Module Permissions
                                                </h6>
                                                <span className="text-muted" style={{ fontSize: "12px" }}>
                                                    Configure read, write, update, and delete access for each module
                                                </span>
                                            </div>

                                            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm"
                                                    style={{ backgroundColor: "#FFF7ED", color: "#F97316", border: "1px solid #FFEDD5", borderRadius: "8px", fontWeight: 600, fontSize: "12px", padding: "6px 12px" }}
                                                    onClick={() => {
                                                        const updated: any = {};
                                                        visibleModules.forEach(m => {
                                                            updated[m.key] = { p_read: true, p_write: true, p_update: true, p_delete: true };
                                                        });
                                                        setRoles((prev: any) => ({ ...prev, permission: { ...prev.permission, ...updated } }));
                                                    }}
                                                >
                                                    <i className="fas fa-check-double mr-1"></i> Grant All
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm"
                                                    style={{ backgroundColor: "#F8FAFC", color: "#64748B", border: "1px solid #E2E8F0", borderRadius: "8px", fontWeight: 600, fontSize: "12px", padding: "6px 12px" }}
                                                    onClick={() => {
                                                        const updated: any = {};
                                                        visibleModules.forEach(m => {
                                                            updated[m.key] = { p_read: false, p_write: false, p_update: false, p_delete: false };
                                                        });
                                                        setRoles((prev: any) => ({ ...prev, permission: { ...prev.permission, ...updated } }));
                                                    }}
                                                >
                                                    <i className="fas fa-times mr-1"></i> Clear All
                                                </button>
                                            </div>
                                        </div>

                                        <div className="table-responsive" style={{ borderRadius: "14px", border: "1px solid #E2E8F0", overflow: "hidden" }}>
                                            <table className="table table-hover mb-0" style={{ background: "#FFFFFF" }}>
                                                <thead style={{ backgroundColor: "#F8FAFC", borderBottom: "1px solid #E2E8F0" }}>
                                                    <tr>
                                                        <th style={{ padding: "14px 20px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "32%" }}>
                                                            MODULE
                                                        </th>
                                                        <th className="text-center" style={{ padding: "14px 12px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "13%" }}>
                                                            <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => toggleColumnAll("p_read")} title="Toggle all Read permissions">
                                                                READ <i className="fas fa-sort ml-1 text-muted" style={{ fontSize: "10px" }}></i>
                                                            </span>
                                                        </th>
                                                        <th className="text-center" style={{ padding: "14px 12px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "13%" }}>
                                                            <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => toggleColumnAll("p_write")} title="Toggle all Write permissions">
                                                                WRITE <i className="fas fa-sort ml-1 text-muted" style={{ fontSize: "10px" }}></i>
                                                            </span>
                                                        </th>
                                                        <th className="text-center" style={{ padding: "14px 12px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "13%" }}>
                                                            <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => toggleColumnAll("p_update")} title="Toggle all Update permissions">
                                                                UPDATE <i className="fas fa-sort ml-1 text-muted" style={{ fontSize: "10px" }}></i>
                                                            </span>
                                                        </th>

                                                        {deleteable == 1 && (
                                                            <th className="text-center" style={{ padding: "14px 12px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "13%" }}>
                                                                <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => toggleColumnAll("p_delete")} title="Toggle all Delete permissions">
                                                                    DELETE <i className="fas fa-sort ml-1 text-muted" style={{ fontSize: "10px" }}></i>
                                                                </span>
                                                            </th>
                                                        )}

                                                        <th className="text-center" style={{ padding: "14px 12px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "16%" }}>
                                                            ALL
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {visibleModules.map((item) => {
                                                        const perms = roles?.permission?.[item.key] || {};
                                                        const isAll = perms.p_read && perms.p_write && perms.p_update && perms.p_delete;
                                                        return (
                                                            <tr key={item.key} style={{ borderBottom: "1px solid #F1F5F9" }}>
                                                                <td style={{ padding: "14px 20px", verticalAlign: "middle" }}>
                                                                    <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                                                                        <div
                                                                            style={{
                                                                                width: "32px",
                                                                                height: "32px",
                                                                                borderRadius: "8px",
                                                                                backgroundColor: "#FFF7ED",
                                                                                color: "#F97316",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                fontSize: "13px"
                                                                            }}
                                                                        >
                                                                            <i className={item.icon}></i>
                                                                        </div>
                                                                        <span style={{ fontWeight: 600, color: "#1E293B", fontSize: "14px" }}>
                                                                            {item.label}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                {/* Read */}
                                                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ width: "18px", height: "18px", accentColor: "#F97316", cursor: "pointer" }}
                                                                        checked={Boolean(perms.p_read)}
                                                                        onChange={() => handlePermissionToggle(item.key, "p_read")}
                                                                    />
                                                                </td>

                                                                {/* Write */}
                                                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ width: "18px", height: "18px", accentColor: "#F97316", cursor: "pointer" }}
                                                                        checked={Boolean(perms.p_write)}
                                                                        onChange={() => handlePermissionToggle(item.key, "p_write")}
                                                                    />
                                                                </td>

                                                                {/* Update */}
                                                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ width: "18px", height: "18px", accentColor: "#F97316", cursor: "pointer" }}
                                                                        checked={Boolean(perms.p_update)}
                                                                        onChange={() => handlePermissionToggle(item.key, "p_update")}
                                                                    />
                                                                </td>

                                                                {/* Delete */}
                                                                {deleteable == 1 && (
                                                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ width: "18px", height: "18px", accentColor: "#F97316", cursor: "pointer" }}
                                                                            checked={Boolean(perms.p_delete)}
                                                                            onChange={() => handlePermissionToggle(item.key, "p_delete")}
                                                                        />
                                                                    </td>
                                                                )}

                                                                {/* Toggle Row All */}
                                                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        style={{
                                                                            backgroundColor: isAll ? "#DCFCE7" : "#F8FAFC",
                                                                            color: isAll ? "#16A34A" : "#475569",
                                                                            borderRadius: "8px",
                                                                            padding: "4px 14px",
                                                                            fontSize: "12px",
                                                                            fontWeight: 700,
                                                                            border: isAll ? "1px solid #BBF7D0" : "1px solid #E2E8F0",
                                                                            boxShadow: isAll ? "0 1px 3px rgba(22, 163, 74, 0.15)" : "none",
                                                                            transition: "all 0.2s ease",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => toggleRowAll(item.key)}
                                                                    >
                                                                        {isAll ? "All ✓" : "Toggle"}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="col-12 mt-4 d-flex" style={{ gap: "12px" }}>
                                        {isUpdate ? (
                                            <button
                                                type="button"
                                                className="btn text-white d-inline-flex align-items-center"
                                                style={{ backgroundColor: "#F97316", borderRadius: "10px", padding: "12px 28px", fontWeight: 700, border: "none" }}
                                                onClick={updateRole}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <CircularProgress size={18} color="inherit" className="mr-2" /> : <i className="fas fa-save mr-2"></i>}
                                                Update Role
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn text-white d-inline-flex align-items-center"
                                                style={{ backgroundColor: "#F97316", borderRadius: "10px", padding: "12px 28px", fontWeight: 700, border: "none" }}
                                                onClick={creareRoleHandler}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <CircularProgress size={18} color="inherit" className="mr-2" /> : <i className="fas fa-plus mr-2"></i>}
                                                Save Role
                                            </button>
                                        )}

                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            style={{ borderRadius: "10px", padding: "12px 24px", fontWeight: 600, color: "#64748B", border: "1px solid #CBD5E1" }}
                                            onClick={() => {
                                                setIsListing(false);
                                                ListHanler();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            /* ── Roles Listing View ── */
                            <div className="p-4" style={{ minHeight: "65vh" }}>
                                {/* Filter Bar */}
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap" style={{ gap: "15px" }}>
                                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                        <div style={{ position: "relative", width: "280px" }}>
                                            <i className="fas fa-search" style={{ position: "absolute", left: "14px", top: "14px", color: "#94A3B8", fontSize: "14px" }}></i>
                                            <input
                                                type="search"
                                                className="form-control"
                                                placeholder="Search roles..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value.trimStart())}
                                                style={{
                                                    paddingLeft: "38px",
                                                    borderRadius: "10px",
                                                    border: "1px solid #CBD5E1",
                                                    fontSize: "14px",
                                                    height: "42px"
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        {/* <button 
                                            className="btn text-white"
                                            style={{ backgroundColor: "#F97316", borderRadius: "10px", padding: "9px 20px", fontWeight: 600, fontSize: "13px", border: "none" }}
                                            onClick={() => setCreate()}
                                        >
                                            <i className="fas fa-plus mr-2"></i> Create New Role
                                        </button> */}
                                    </div>
                                </div>

                                {listingLoading ? (
                                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "45vh", gap: "12px" }}>
                                        <CircularProgress style={{ color: "#F97316" }} />
                                        <span className="font-weight-bold" style={{ color: "#64748B", fontSize: "14px" }}>
                                            Loading roles, please wait...
                                        </span>
                                    </div>
                                ) : filteredRoles.length > 0 ? (
                                    <>
                                        {/* Desktop Table View */}
                                        <div className="table-responsive d-none d-md-block" style={{ borderRadius: "14px", border: "1px solid #E2E8F0", overflow: "scroll", height: "60vh" }}>
                                            <table className="table table-hover mb-0">
                                                <thead style={{ backgroundColor: "#F8FAFC", borderBottom: "1px solid #E2E8F0" }}>
                                                    <tr>
                                                        <th style={{ padding: "14px 20px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "10%" }}>S.NO</th>
                                                        <th style={{ padding: "14px 20px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "45%" }}>ROLE NAME</th>
                                                        <th style={{ padding: "14px 20px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "25%" }}>STATUS</th>
                                                        <th className="text-center" style={{ padding: "14px 20px", color: "#475569", fontWeight: 700, fontSize: "13px", width: "20%" }}>ACTIONS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredRoles.map((item: any, index: any) => (
                                                        <tr key={item?.id || index} style={{ borderBottom: "1px solid #F1F5F9" }}>
                                                            <td style={{ padding: "16px 20px", color: "#64748B", fontSize: "14px", fontWeight: 600, verticalAlign: "middle" }}>
                                                                {index + 1}
                                                            </td>
                                                            <td style={{ padding: "16px 20px", verticalAlign: "middle" }}>
                                                                <span style={{ fontWeight: 700, color: "#0F172A", fontSize: "15px" }}>
                                                                    {item?.role_name}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: "16px 20px", verticalAlign: "middle" }}>
                                                                <span
                                                                    style={{
                                                                        backgroundColor: item?.status ? "#DCFCE7" : "#FEE2E2",
                                                                        color: item?.status ? "#15803D" : "#DC2626",
                                                                        padding: "5px 14px",
                                                                        borderRadius: "20px",
                                                                        fontSize: "12px",
                                                                        fontWeight: 600,
                                                                        display: "inline-block"
                                                                    }}
                                                                >
                                                                    {item?.status ? "Active" : "Inactive"}
                                                                </span>
                                                            </td>
                                                            <td className="text-center" style={{ padding: "16px 20px", verticalAlign: "middle" }}>
                                                                <div className="d-flex justify-content-center align-items-center" style={{ gap: "8px" }}>
                                                                    {role?.p_update && (
                                                                        <button
                                                                            style={{
                                                                                width: "36px",
                                                                                height: "36px",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: "#3B82F6",
                                                                                color: "#FFFFFF",
                                                                                border: "none",
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                cursor: "pointer",
                                                                                boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                                                                                transition: "all 0.2s ease"
                                                                            }}
                                                                            onClick={() => editRedirect(item?.id)}
                                                                            title="Edit Role"
                                                                        >
                                                                            <i className="fas fa-pen" style={{ fontSize: "13px" }}></i>
                                                                        </button>
                                                                    )}

                                                                    {role?.p_delete && (
                                                                        <button
                                                                            style={{
                                                                                width: "36px",
                                                                                height: "36px",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: "#EF4444",
                                                                                color: "#FFFFFF",
                                                                                border: "none",
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                cursor: "pointer",
                                                                                boxShadow: "0 2px 6px rgba(239, 68, 68, 0.3)",
                                                                                transition: "all 0.2s ease"
                                                                            }}
                                                                            onClick={() => deleteRole(item?.id)}
                                                                            title="Delete Role"
                                                                        >
                                                                            <i className="fas fa-trash" style={{ fontSize: "13px" }}></i>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Mobile Card View */}
                                        <div className="d-block d-md-none">
                                            {filteredRoles.map((item: any, index: any) => (
                                                <div
                                                    key={item?.id || index}
                                                    className="p-3 mb-3 bg-white"
                                                    style={{ borderRadius: "14px", border: "1px solid #E2E8F0", boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="font-weight-bold" style={{ fontSize: "16px", color: "#0F172A" }}>
                                                            {item?.role_name}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: item?.status ? "#DCFCE7" : "#FEE2E2",
                                                                color: item?.status ? "#15803D" : "#DC2626",
                                                                padding: "4px 10px",
                                                                borderRadius: "14px",
                                                                fontSize: "11px",
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {item?.status ? "Active" : "Inactive"}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-end mt-3" style={{ gap: "8px" }}>
                                                        {role?.p_update && (
                                                            <button
                                                                className="btn btn-sm text-white"
                                                                style={{ backgroundColor: "#3B82F6", borderRadius: "8px", fontWeight: 600, padding: "6px 14px" }}
                                                                onClick={() => editRedirect(item?.id)}
                                                            >
                                                                <i className="fas fa-pen mr-1"></i> Edit
                                                            </button>
                                                        )}
                                                        {role?.p_delete && (
                                                            <button
                                                                className="btn btn-sm text-white"
                                                                style={{ backgroundColor: "#EF4444", borderRadius: "8px", fontWeight: 600, padding: "6px 14px" }}
                                                                onClick={() => deleteRole(item?.id)}
                                                            >
                                                                <i className="fas fa-trash mr-1"></i> Delete
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="d-flex flex-column justify-content-center align-items-center text-center p-5" style={{ minHeight: "40vh", gap: "10px" }}>
                                        <i className="fas fa-user-shield" style={{ fontSize: "42px", color: "#CBD5E1" }}></i>
                                        <span className="font-weight-bold" style={{ fontSize: "16px", color: "#64748B" }}>
                                            {searchTerm ? "No roles match your search" : "No roles created yet"}
                                        </span>
                                        <p className="text-muted" style={{ fontSize: "13px", maxWidth: "350px" }}>
                                            Click "Create New Role" above to set up custom permission sets for your staff.
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </ThemeMaker>
    );
};

export default Roles;
